import React, { isValidElement } from 'react';

import type { TTextContent } from './models';

export const TextContent = ({
    Text,
    createTree = null,
    step: { text, textTree },
    styles,
    view,
}: TTextContent) => {
    if (textTree && createTree) {
        return createTree(textTree);
    }

    if (textTree && isValidElement(textTree)) {
        return textTree;
    }

    if (text) {
        return (
            <div className={styles.stepTextWrapper}>
                <Text kind="caption" styler={{ marginBottom: 0, marginTop: 0 }} view={view}>
                    {text}
                </Text>
            </div>
        );
    }

    return null;
};
